export const Data = [
  {
    text: 'Notice 17th AGM',
    key: 1,
    filePath: '/docs/InvestorRelations/JPSL-AGM-Notice-FY-2023-24.pdf',
  },
  {
    text: 'Draft Annual Return FY 2023-24',
    key: 1,
    filePath: '/docs/InvestorRelations/JPSL-Annual-Return-2023-24.pdf',
  },
  {
    text: 'Policy for Selection of Directors and Determining Director’s Independence',
    key: 3,
    filePath: '/docs/InvestorRelations/Policy-for-Selection-of-Directors-and-determining-Directors-Independence.pdf',
  },
  {
    text: 'Remuneration Policy for Directors, Key Managerial Personnel and other Employees',
    key: 4,
    filePath: '/docs/InvestorRelations/Remuneration-Policy-for-Directors-Key-Managerial-Personnel-and-other-Employees.pdf',
  },
]
